import type { FC, ReactElement } from "react"

const Icon: FC = (): ReactElement => <>🚧</>

Icon.displayName = "CoachingChatError2Icon"

export { Icon as CoachingChatError2Icon }
